import React from 'react';
import Skeleton from './Skeleton';

interface SkeletonCardProps {
  count?: number;
}

const SkeletonCard: React.FC<SkeletonCardProps> = ({ count = 1 }) => {
  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="p-3 bg-[#e8f0f8] border border-[#d5ddea] rounded-lg"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-center flex-1">
              <Skeleton width="w-6" height="h-6" variant="circle" className="mr-2" />
              <div className="flex-1">
                <Skeleton width="w-20" height="h-4" className="mb-2" />
                <Skeleton width="w-16" height="h-3" />
              </div>
            </div>
            <Skeleton width="w-12" height="h-4" />
          </div>

          <Skeleton width="w-full" height="h-4" className="mb-2" />
          <Skeleton width="w-3/4" height="h-4" className="mb-3" />

          <div className="flex items-center space-x-2">
            <Skeleton width="w-12" height="h-3" />
            <Skeleton width="w-1" height="h-3" />
            <Skeleton width="w-16" height="h-3" />
            <Skeleton width="w-1" height="h-3" />
            <Skeleton width="w-10" height="h-3" />
          </div>
        </div>
      ))}
    </>
  );
};

export const VideoSkeleton: React.FC = () => {
  return (
    <div className="panel p-6 h-full min-h-[400px]">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <Skeleton width="w-6" height="h-6" variant="circle" className="mr-2" />
          <Skeleton width="w-32" height="h-6" />
        </div>
        <Skeleton width="w-20" height="h-4" />
      </div>

      <div className="aspect-video bg-[#d5ddea] rounded-lg mb-4 flex items-center justify-center">
        <Skeleton width="w-16" height="h-16" variant="circle" />
      </div>

      <div className="flex space-x-2 mb-4">
        <Skeleton width="w-full" height="h-10" />
        <Skeleton width="w-full" height="h-10" />
        <Skeleton width="w-full" height="h-10" />
      </div>

      <div className="p-3 bg-[#e8f0f8] rounded-lg border border-[#d5ddea]">
        <Skeleton width="w-20" height="h-3" className="mb-2" />
        <Skeleton width="w-full" height="h-4" />
      </div>
    </div>
  );
};

export const ProviderSkeleton: React.FC = () => {
  return (
    <div className="panel p-6">
      <div className="flex items-center mb-4">
        <Skeleton width="w-6" height="h-6" variant="circle" className="mr-2" />
        <Skeleton width="w-32" height="h-6" />
      </div>

      <div className="flex space-x-2 mb-4 border-b border-[#d5ddea] pb-3">
        <Skeleton width="w-full" height="h-8" />
        <Skeleton width="w-full" height="h-8" />
        <Skeleton width="w-full" height="h-8" />
        <Skeleton width="w-full" height="h-8" />
      </div>

      <div className="space-y-3">
        <div className="p-3 bg-[#e8f0f8] rounded-lg border border-[#d5ddea]">
          <Skeleton width="w-40" height="h-5" className="mb-2" />
          <Skeleton width="w-full" height="h-4" />
        </div>

        <div className="grid grid-cols-2 gap-2">
          <div className="p-2 bg-[#e8f0f8] rounded border border-[#d5ddea]">
            <Skeleton width="w-16" height="h-3" className="mb-1" />
            <Skeleton width="w-12" height="h-4" />
          </div>
          <div className="p-2 bg-[#e8f0f8] rounded border border-[#d5ddea]">
            <Skeleton width="w-16" height="h-3" className="mb-1" />
            <Skeleton width="w-12" height="h-4" />
          </div>
        </div>

        <div className="p-3 bg-[#e8f0f8] rounded-lg border border-[#d5ddea]">
          <Skeleton width="w-32" height="h-3" className="mb-2" />
          <div className="space-y-1">
            <Skeleton width="w-full" height="h-4" />
            <Skeleton width="w-full" height="h-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export const CostSkeleton: React.FC = () => {
  return (
    <div className="panel p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <Skeleton width="w-6" height="h-6" variant="circle" className="mr-2" />
          <Skeleton width="w-48" height="h-5" />
        </div>
        <div className="text-right">
          <Skeleton width="w-20" height="h-6" className="mb-1" />
          <Skeleton width="w-24" height="h-3" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
